import {createFeatureSelector} from '@ngrx/store';

export const getEdit = createFeatureSelector('edit');
